import {Collection} from 'data/records'
import {resource, member, collection as c, findSelector} from 'data/helpers/apiv3'
import {fulfilled} from 'lib/promiseMiddlewareHelpers'
import {OrderedSet} from 'immutable'

const [api, actions] = resource(Collection, [
  ['read', member.get('', ['privacyCode'])],
  ['list', c.get('', ['userId'])]
])

const selectors = {
  ...findSelector(Collection),
  allForUser: (state) => state.apiv3.collection.allForUser.map(cid => selectors.find(state, cid))
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const nextAllForuser = OrderedSet(state.allForUser.concat(action.payload.results.map(r => r.id)))
    return state.set('allForUser', nextAllForuser)
  }
}

// stores all collectionIds to show on the overview page for the currentUser we
// aren't keying off userId because the collections index endpoint only returns
// collections for the currentUser, and currentUser.id _should_ never change
// without a refresh. we'll also use the ordering
const initialState = {
  allForUser: OrderedSet() // OrderedSet([collectionIds])
}

export {
  api as collectionApi,
  actions as collectionActions,
  selectors as collectionSelectors,
  reducers as collectionReducers,
  initialState as collectionInitialState
}
